// extracted by mini-css-extract-plugin
module.exports = {"page_title":"SigninPage_page_title__1yXxw","page_subtitle":"SigninPage_page_subtitle__2qEIp","input_wrapper":"SigninPage_input_wrapper__2Jwk5"};